'use client';

import { useSalePageGachaRankingQuery } from '@/entities/salePage';
import { qaAttr, qaId } from '@/lib/qa';
import { Column, Element, Row } from '@vuddy/components';
import { GachaRankingDate } from './GachaRankingDate';
import GachaRankingItem from './GachaRankingItem';
import GachaStockEmpty from './GachaStockEmpty';

const GachaStockRanking = ({ salePageId }: { salePageId: number }) => {
  const { data } = useSalePageGachaRankingQuery(salePageId);

  const isEmpty = !data || data?.length === 0;
  return (
    <Column
      {...qaAttr(qaId('sale.gacha', 'ranking'))}
      padding="padding_base"
      gap="gap_3xl"
      borderRadius="radius_large"
      backgroundColor="whiteQuaternary"
      id="ranking">
      <Row justifyContent="space-between">
        <Element typography="titleSmall" color="whitePrimary">
          가챠 랭킹
        </Element>

        {data && <GachaRankingDate />}
      </Row>

      {isEmpty ? (
        <GachaStockEmpty />
      ) : (
        <Element as="ul">
          {data?.map((item, index) => {
            return <GachaRankingItem key={index} item={item} />;
          })}
        </Element>
      )}
    </Column>
  );
};

export default GachaStockRanking;
